import React from 'react';
import { Button, Icon } from '@mui/material';
import { PendingActions, ContentPaste } from '@mui/icons-material';
import video from 'Images/video.svg';
import meet from 'Images/meet.svg';
import { VIDEO, MEET, FACE_TO_FACE, AUDIO, MANUAL_EVALUATION, AUTOMATIC_EVALUATION } from 'Constants/General';
import faceToFace from 'Images/faceToFace.svg';
import audio from 'Images/audio.svg';
import useTranslation from 'Hooks/useTranslation';
import { CardContainer, cardStyle, textStyle, buttonStyle, iconStyle } from './style';

export default function SelectLesson({ onCancel, onSelect, module, setCurrentPositionLesson }) {
  const { t2 } = useTranslation('EditCourse');

  const cards = [
    {
      id: 1,
      title: VIDEO,
      text: <h5 style={textStyle}>{t2('Video')}</h5>,
      component: <img src={video} />,
    },
    {
      id: 2,
      title: AUDIO,
      text: <h5 style={textStyle}>{t2('Audio')}</h5>,
      component: <img src={audio} />,
    },
    // { id: 3, img: document, title: DOCUMENT, text: 'doc' },
    {
      id: 3,
      title: MEET,
      text: <h5 style={textStyle}>{t2('Meet')}</h5>,
      component: <img src={meet} />,
    },
    {
      id: 4,
      title: FACE_TO_FACE,
      text: <h5 style={textStyle}>{t2('inPerson')}</h5>,
      component: <img src={faceToFace} />,
    },
    {
      id: 5,
      title: MANUAL_EVALUATION,
      text: <h6 style={textStyle}>{t2('Evaluation')}</h6>,
      component: <ContentPaste />,
    },
    {
      id: 6,
      title: AUTOMATIC_EVALUATION,
      text: <h6 style={textStyle}>{t2('AutoEvalShort')}</h6>,
      component: <PendingActions />,
    },
  ];

  const handleClick = id => {
    const index = id - 1;
    const lessonType = cards[index].title;
    onSelect(lessonType);
    // Si el modulo no contiene ninguna leccion, se le asigna un array vacio
    if (!module?.lessons) {
      module.lessons = [];
    }
    // Posteriormente se agrega la leccion al modulo
    module.lessons.push({
      name: t2('NewLesson'),
      LessonType: { name: lessonType },
    });
    // Se guarda el cambio en el modulo

    onCancel(false);
    setCurrentPositionLesson(module.lessons.length - 1);
  };

  return (
    <div>
      <CardContainer>
        {cards.map((card, index) => (
          <Button key={card.id} style={cardStyle} onClick={() => handleClick(card.id)}>
            <Icon style={iconStyle}>{card.component}</Icon>
            {card.text}
          </Button>
        ))}
      </CardContainer>
      <Button style={buttonStyle} variant="outlined" onClick={() => onCancel(false)}>
        {t2('Cancel')}
      </Button>
    </div>
  );
}
